import { onUnmounted, readonly, ref, type Ref } from 'vue';

import { TOP_LISTING_BUY_PRICE_CHANGE_TIMESTAMP } from '@/helpers/topListingBuyPriceChange';

// setTimeout runs a longer delay at once, so no timer is set when the change is further away.
const MAX_TIMEOUT_DELAY_MS = 2 ** 31 - 1;

/**
 * True from the Top Listing BUY price change on. A page that is open at the cutoff switches at that
 * moment, because `Date.now()` alone does not make a computed value update.
 */
export function useHasTopListingBuyPriceChanged(): Readonly<Ref<boolean>> {
  const delayMs = TOP_LISTING_BUY_PRICE_CHANGE_TIMESTAMP - Date.now();
  const hasChanged = ref(delayMs <= 0);

  if (delayMs > 0 && delayMs <= MAX_TIMEOUT_DELAY_MS) {
    const timeoutId = setTimeout(() => {
      hasChanged.value = true;
    }, delayMs);
    onUnmounted(() => clearTimeout(timeoutId));
  }

  return readonly(hasChanged);
}
